export default class PocherStickyAddToCart {
    constructor(el) {
        this.el = el
        this.setVisibility()
        window.addEventListener('resize', this.setVisibility, { passive: true })
        document.addEventListener('scroll', this.setVisibility, { passive: true })
    }

    setVisibility = () => {
        const hasScrolledPastViewport = window.pageYOffset >= window.innerHeight
        this.el.style.transform = hasScrolledPastViewport ? 'translateY(0)' : 'translateY(100%)'
        this.el.style.transition = 'transform 280ms ease-in-out'
        this.el.style.willChange = 'transform'
    }
}
